import T from './types';

export function setDateRange(dateRange) {
  return {
    type: T.SET_DATE_RANGE,
    dateRange,
  };
}
